import {
  BellSimpleIcon,
  CardholderIcon,
  ClockCountdownIcon,
  CpuIcon,
  CreditCardIcon,
  HeadsetIcon,
  PackageIcon,
  PresentationChartIcon,
  SealPercentIcon,
  SquaresFourIcon,
  TractorIcon,
  UserGearIcon,
  UsersThreeIcon,
  WrenchIcon,
} from '@phosphor-icons/react';
import type { ReactNode } from 'react';

import { routes } from './routes';

export type NavItem = {
  key: string;
  label: string;
  icon?: ReactNode;
  section?: string;
  to?: string;
  roles?: string[];
  children?: NavItem[];
};

export const nav: NavItem[] = [
  {
    key: 'dashboard',
    label: 'Dashboard',
    icon: <SquaresFourIcon size={16} />,
    to: routes.dashboard,
  },
  {
    key: 'orders',
    label: 'Orders',
    icon: <PackageIcon size={16} />,
    section: 'Business',
    to: routes.orders,
  },
  {
    key: 'customers',
    label: 'Customers',
    icon: <UsersThreeIcon size={16} />,
    section: 'Business',
    to: routes.customers,
  },
  {
    key: 'products',
    label: 'Products',
    icon: <TractorIcon size={16} />,
    section: 'Business',
    children: [
      { key: 'products-list', label: 'Catalog', to: routes.products },
      { key: 'bundles', label: 'Bundles', to: routes.bundles },
    ],
  },
  {
    key: 'installations',
    label: 'Installations',
    icon: <WrenchIcon size={16} />,
    section: 'Business',
    to: routes.installations,
  },
  {
    key: 'devices',
    label: 'Devices',
    icon: <CpuIcon size={16} />,
    section: 'Business',
    to: routes.devices,
  },
  {
    key: 'support',
    label: 'Support',
    icon: <HeadsetIcon size={16} />,
    section: 'Support',
    to: routes.support,
  },
  {
    key: 'subscriptions',
    label: 'Subscriptions',
    icon: <CardholderIcon size={16} />,
    section: 'Support',
    to: routes.subscriptions,
  },
  {
    key: 'payments',
    label: 'Payments',
    icon: <CreditCardIcon size={16} />,
    section: 'Finance',
    to: routes.payments,
  },
  {
    key: 'reports',
    label: 'Reports',
    icon: <PresentationChartIcon size={16} />,
    section: 'Finance',
    children: [
      { key: 'reports-orders', label: 'Orders Summary', to: routes.reportOrders },
      { key: 'reports-device-count', label: 'Device Count', to: routes.reportDeviceCount },
      { key: 'reports-device-activity', label: 'Device Activity', to: routes.reportDeviceActivity },
      { key: 'reports-customer-usage', label: 'Customer Usage', to: routes.reportCustomerUsage },
      { key: 'reports-subscription', label: 'Subscription', to: routes.reportSubscription },
    ],
  },
  {
    key: 'notifications',
    label: 'Notifications',
    icon: <BellSimpleIcon size={16} />,
    to: routes.notifications,
  },
  {
    key: 'activity-log',
    label: 'Activity Log',
    icon: <ClockCountdownIcon size={16} />,
    to: routes.activityLog,
  },
  {
    key: 'configurations',
    label: 'Configurations',
    icon: <SealPercentIcon size={16} />,
    section: 'Admin',
    roles: ['Admin'],
    children: [
      { key: 'config-tax', label: 'Tax', to: routes.configTax },
      { key: 'config-discounts', label: 'Discounts', to: routes.configDiscounts },
      {
        key: 'config-installation-fees',
        label: 'Installation Fees',
        to: routes.configInstallationFees,
      },
      { key: 'config-warranty', label: 'Warranty Periods', to: routes.configWarrantyPeriods },
    ],
  },
  {
    key: 'admin-users',
    label: 'User Management',
    icon: <UserGearIcon size={16} />,
    section: 'Admin',
    roles: ['Admin'],
    to: routes.adminUsers,
  },
];
